import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {  Card, CardBody, Container, CardHeader,  CardFooter } from 'reactstrap';
import IButtonComponent from '../iComponents/iButton/IButton';
import { DownloadFile, DownloaFilesInZIP, getIconByExtension, isDisabledPreview, PreviewFile } from '../../../helpers/attachments_helper';
import { useDispatch, useSelector } from 'react-redux';
import '../ShowAttachments/ShowAttachments.scss';
import Iloading from '../iComponents/iLoading/Iloading';
import { getDocuments, getOneDocument } from '../../../store/documents/actions';

const ShowDocuments = ({ GUID, type, Number }: any) => {
    const { documentList, isLoading, documentData, isLoadingBase64 } = useSelector((state: any) => state.Documents);
    const dispatch = useDispatch();
    const [documents, setDocuments] = useState<any>([]);
    const [selectedDocument, setSelectedDocument] = useState<any>('');
    const [base64Document, setbase64Document] = useState<any>('');
    const [cacheBase64Doc, setcacheBase64Doc] = useState<any>([]);
    const [searchTerm, setSearchTerm] = useState<string>('');

    useEffect(() => {
        dispatch(getDocuments({ GUID, type }));
    }, []);
    useEffect(() => {
        setDocuments(documentList);
    }, [documentList]);

    useEffect(() => {
        if (documentData) {
            setbase64Document(documentData);
            setcacheBase64Doc([...cacheBase64Doc, { ...documentData, isSelected: false }]);
        }
    }, [documentData]);

    useEffect(() => {
        if (selectedDocument) {
            const { Identifier, ShipmentGUID } = selectedDocument;
            const isExist = cacheBase64Doc.find((obj: any) => obj.Identifier === Identifier);
            if (!isExist) {
                dispatch(getOneDocument({ GUID: ShipmentGUID, Identifier }));
            } else {
                setbase64Document(isExist);
            }
        }
    }, [selectedDocument]);

    const handleSelectDoc = (doc: any) => {
        setSelectedDocument(doc);
    };
    const handleDownload = () => {
        const Data = base64Document.Data;
        if (selectedDocument && base64Document) DownloadFile({ ...selectedDocument, Data });
    };
    const handlePreview = () => {
        const Data = base64Document.Data;
        if (selectedDocument && base64Document) PreviewFile({ ...selectedDocument, Data });
    };
    const handleDownloadZIP = async () => {
        const checkDocs = documents.filter((doc: any) => doc.isSelected);
        const filteredCacheBase64Doc = cacheBase64Doc
            .map((base64doc: any) => {
                const matchingDoc = checkDocs.find((doc: any) => doc.Identifier === base64doc.Identifier);
                if (matchingDoc) {
                    return {
                        ...base64doc,
                        Extension: matchingDoc.Extension,
                        Name: matchingDoc.Name,
                        ShipmentNumber: matchingDoc.ShipmentNumber
                    };
                }
                return null;
            })
            .filter((item: any) => item !== null);

        if (checkDocs.length > 0) {
            await DownloaFilesInZIP(filteredCacheBase64Doc, type, Number, 'documents');
        }
    };
    const validIdenticator = (identifier: any) => {
        return identifier === selectedDocument.Identifier;
    };
    const isDisabledButtonZIP = () => {
        const checkDocs = documents.filter((doc: any) => doc.isSelected);
        return checkDocs.length === 0;
    };
    const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(event.target.value);
    };
    const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>, Identifier: string) => {
        const isChecked = event.target.checked;
        const updatedDocs = documents.map((doc: any) => {
            if (doc.Identifier === Identifier) {
                return { ...doc, isSelected: isChecked };
            }
            return doc;
        });
        setDocuments(updatedDocs);
    };
    const validateExistInCache = (Identifier: string) => {
        const isExist = cacheBase64Doc.find((obj: any) => obj.Identifier === Identifier);
        if (isExist) return <i className="bx bx-down-arrow-circle" style={{ fontSize: '2.5rem' }}></i>;
    };
    const LoadingIndicator = () => {
        return (
            <div className="d-flex justify-content-center">
                <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    };
    const filteredDocs = documents.filter((doc: any) => doc.Name.toLowerCase().includes(searchTerm.toLowerCase()));
    return (
        <Container>
            <div className="container-sm">
                <Iloading loading={isLoadingBase64} />
            </div>
            <Card className={'container-ShowAttachments'}>
                <CardHeader className="cardHeader">
                    <h2 style={{ color: 'white' }}>
                        Documents - {type} - {Number}
                    </h2>
                    <div className="search__container">
                        <input type="text" placeholder="Search..." value={searchTerm} onChange={handleSearchChange} className="search-input" />
                    </div>
                </CardHeader>
                <CardBody>
                    <div className="container-sm">
                        <>{isLoading ? LoadingIndicator() : null}</>
                    </div>
                    <div className={'container-attachments'}>
                        {filteredDocs.map((doc: any) => (
                            <div
                                key={doc.Identifier}
                                className={`attachment-item ${validIdenticator(doc.Identifier) && 'selected-attachment'}`}
                                onClick={() => handleSelectDoc(doc)}
                            >
                                <i className={getIconByExtension(doc.Extension)}></i>
                                <span>
                                    {doc.Name} - {doc.LayoutType} - {doc.ShipmentNumber}
                                </span>
                                <div className="custom-checkbox">
                                    {validateExistInCache(doc.Identifier)}
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id={`formCheck-${doc.Identifier}`}
                                        aria-checked={doc.isSelected}
                                        onChange={(event: any) => handleCheckboxChange(event, doc.Identifier)}
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                </CardBody>
                <CardFooter className="container_buttons_attachments">
                    {documents.length > 0 && (
                        <IButtonComponent
                            className="btn-search text-nowrap w-auto"
                            actionOnClick={() => handleDownloadZIP()}
                            label={`Download Checked`}
                            btnIcon="dripicons-folder-open"
                            disabled={isDisabledButtonZIP()}
                        ></IButtonComponent>
                    )}
                    {selectedDocument && (
                        <div className="d-flex" style={{ marginLeft: 'auto' }}>
                            <IButtonComponent
                                className="btn-search"
                                actionOnClick={() => handleDownload()}
                                label={`Download`}
                                btnIcon="dripicons-download"
                            ></IButtonComponent>
                            <IButtonComponent
                                className="btn-search"
                                actionOnClick={() => handlePreview()}
                                label={`Preview`}
                                btnIcon="dripicons-preview"
                                disabled={isDisabledPreview(selectedDocument.Extension)}
                            ></IButtonComponent>
                        </div>
                    )}
                </CardFooter>
            </Card>
        </Container>
    );
};

ShowDocuments.propTypes = {
    GUID: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    Number: PropTypes.string.isRequired,
};

export default ShowDocuments;
